module.exports = __webpack_public_path__ + "img/fitness friend.467abe4b.png";